// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as CrmControlledReleaseRepoConfig from "./CrmControlledReleaseRepoConfig.bs.js";

var betaUserDummyUsecase1 = {
        "admin": {
          "id": 223,
          "name": "test",
          "email": "test@xyz.com"
        },
        "page_config": [{
            "page_name": "edit_order", 
            "version_access": "beta"
          },
          {
            "page_name": "adjust_fare",
            "version_access": "beta"
          },
          {
            "page_name": "customer_profile",
            "version_access": "beta"
          },
          {
            "page_name": "send_sms",
            "version_access": "beta"
          }
        ]
      };

function getAdminBetaAcessData(country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: betaUserDummyUsecase1
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CrmControlledReleaseRepoConfig.BetaUserResponseConverter.execute, result);
                        });
            });
}

var BetaUserRepo = {
  getAdminBetaAcessData: getAdminBetaAcessData
};

export {
  BetaUserRepo ,
  
}
/* CrmControlledReleaseRepoConfig Not a pure module */
